// extracted by mini-css-extract-plugin
module.exports = {"comb":"comb-module--comb--2ZPl5","iconWrapper":"comb-module--icon-wrapper--3ykBM","iconContent":"comb-module--icon-content--1-55L"};